<template>
    <ImageItem
        v-if="imageSrc"
        class="preview-container preview-image overflow-hidden"
        :image-src="imageSrc"
        scaling="contain"
        background-color="transparent"
    />
    <div v-else class="preview-container default-preview-image">
        <i :class="fallbackIcon" class="fa-light fa-3x" />
    </div>
</template>

<script setup lang="ts">
import ImageItem from "@/shared/components/image-item/image-item.vue";

defineProps<{
    imageSrc?: string;
    fallbackIcon: string;
}>();
</script>

<style lang="scss" scoped>
.preview-container {
    aspect-ratio: 4 / 3;
    display: flex;
    justify-content: center;
    height: 100%;
    width: 100%;
    border-radius: $default-border-radius;
}

.preview-image {
    background-color: transparent;
}

.default-preview-image {
    align-items: center;
    background-color: $icon-background-color;

    i {
        color: $icon-color-light;
    }
}
</style>
